<!--
 * @Author: chenyourong
 * @Date: 2025-05-08 18:06:50
 * @LastEditors: chenyourong
 * @LastEditTime: 2025-06-26 14:28:52
 * @Description: 
 * @FilePath: /vue-admin-template-master/src/views/order/orderList/index.vue
-->
<template>
  <div class="order-list">
    <Search v-bind="filterAttrs" v-on="filterEvent"></Search>
    <Table
      :list-query-params.sync="listQueryParams"
      v-bind="tableAttrs"
      v-on="tableEvent"
    />
  </div>
</template>

<script>
import Table from "@/components/Table/index.vue";
import Detail from "@/components/Detail/index.vue";
import Search from "@/components/Search/index.vue";
import XLSX from "xlsx";
import Cookies from "js-cookie";
import { getPathName } from "@/utils/index.js";

import { orderList, reverseOrder, expireOrder } from "@/api/order";
import { merchantList } from "@/api/business.js";
import { channelList } from "@/api/channel.js";
import { storesList } from "@/api/business";

const DefaultTableQuery = {
  pageNum: 1,
  pageSize: 10,
};

const ORDER_LIST_STATE_KEY = "order_list_query_state";
const EXPORT_PAGE_SIZE = 10000;
const EXPORT_REQUEST_TIMEOUT = 120000;

export default {
  name: "orderList",
  components: {
    Table,
    Search,
    Detail,
  },
  data() {
    return {
      // 参数
      type: +Cookies.get("type"),
      listQueryParams: { ...DefaultTableQuery },
      tableData: [],
      tableConfig: [
        {
          label: "券码ID",
          minWidth: "120",
          maxWidth: "220",
          autoWidth: true,
          value: "voucherId",
        },
        {
          label: "年月",
          minWidth: "80",
          maxWidth: "110",
          autoWidth: true,
          value: "createYearMonth",
        },
        {
          label: "券码金额",
          minWidth: "80",
          maxWidth: "110",
          autoWidth: true,
          value: "amount",
        },
        {
          label: "券码名称",
          minWidth: "110",
          maxWidth: "280",
          autoWidth: true,
          value: "voucherDesc",
        },
        {
          label: "商户",
          minWidth: "90",
          maxWidth: "220",
          autoWidth: true,
          value: "merchantName",
        },
        {
          label: "核销门店",
          minWidth: "90",
          maxWidth: "280",
          autoWidth: true,
          value: "storeName",
        },
        {
          label: "商户金额",
          minWidth: "80",
          maxWidth: "120",
          autoWidth: true,
          value: "merchantSettlement",
        },
        {
          label: "渠道",
          minWidth: "90",
          maxWidth: "240",
          autoWidth: true,
          value: "channelName",
        },
        {
          label: "渠道金额",
          minWidth: "80",
          maxWidth: "120",
          autoWidth: true,
          value: "advancePayment",
        },
        {
          label: "创建时间",
          minWidth: "96",
          maxWidth: "190",
          autoWidth: true,
          value: "createTime",
        },
        {
          label: "过期时间",
          minWidth: "96",
          maxWidth: "190",
          autoWidth: true,
          value: "expireTime",
        },
        {
          label: "操作时间",
          minWidth: "96",
          maxWidth: "190",
          autoWidth: true,
          value: "statusTime",
        },
        {
          label: "状态",
          minWidth: "70",
          maxWidth: "90",
          autoWidth: true,
          value: "specialStatus",
        },
        {
          label: "商户订单号",
          minWidth: "120",
          maxWidth: "220",
          autoWidth: true,
          value: "outOrdId",
        },
        {
          label: "核销单号",
          minWidth: "120",
          maxWidth: "220",
          autoWidth: true,
          value: "checkOrdId",
        },
        {
          label: "外部卡号",
          minWidth: "120",
          maxWidth: "220",
          autoWidth: true,
          value: "cardNo",
        },
      ],
      // 表格加载loading
      loadingStatus: false,
      buttonsName: [
        {
          label: "查看",
        },
        {
          label: "",
        },
      ],
      optionWidth: 148,
      // url参数
      params: {
        pageSize: 10,
        pageNum: 0,
        merchantId: "",
        channelId: "",
        storeId: "",
        voucherId: "",
        order_id: "",
        checkStoreName: "",
      },
      filterButtonText: [
        {
          label: "导出Excel",
          type: "primary",
        },
      ],
      filterOptions: [
        {
          format: "mulDate",
        },
        [3, 4].includes(+Cookies.get("type"))
          ? {}
          : {
              type: "multiSelect",
              placeholder: "商户",
              inputValue: "",
              isSearch: false,
              noShowInput: true,
              // inputWidth: "150px",
              // selectWidth: "110px",
              options: [],
            },
        +Cookies.get("type") === 1
          ? {
              type: "multiSelect",
              placeholder: "渠道",
              inputValue: "",
              isSearch: false,
              // inputWidth: "150px",
              // selectWidth: "110px",
              noShowInput: true,
              options: [],
            }
          : {},
        +Cookies.get("type") === 2
          ? {}
          : {
              type: "multiSelect",
              placeholder: "门店",
              inputValue: "",
              isSearch: false,
              // inputWidth: "150px",
              // selectWidth: "110px",
              noShowInput: true,
              options: [],
            },
        {
          type: "multiSelect",
          placeholder: "状态",
          inputValue: "",
          isSearch: false,
          // inputWidth: "150px",
          // selectWidth: "110px",
          noShowInput: true,
          options: [
            {
              value: null,
              label: "所有",
            },
            {
              value: "0",
              label: "待核销",
            },
            {
              value: "1",
              label: "已核销",
            },
            {
              value: "2",
              label: "冲正",
            },
            {
              value: "3",
              label: "作废",
            },
            {
              value: "4",
              label: "过期",
            },
          ],
        },
        {
          type: "multiSelect",
          placeholder: "请选择",
          selectValue: "voucherId",
          inputValue: "",
          isSearch: false,
          inputWidth: "264px",
          selectWidth: "136px",
          itemClass: "order-search-field",
          options: [
            {
              label: "券码ID",
              value: "voucherId",
            },
            {
              label: "核销订单ID",
              value: "order_id",
            },
            {
              label: "核销门店",
              value: "checkStoreName",
            },
          ],
        },
        {
          type: "button",
        },
      ],
      multipleSelection: [],
    };
  },
  computed: {
    // 表格属性
    tableAttrs() {
      const highlight = this.searchHighlight;
      const config = this.tableConfig.map((item) => {
        if (!highlight.columns.includes(item.value) || !highlight.keyword) {
          return item;
        }
        return {
          ...item,
          format: "highlight",
          highlightKeyword: highlight.keyword,
        };
      });
      return {
        // 表头配置
        config,
        // 表格数据
        tableData: this.tableData,
        // loading
        loadingStatus: this.loadingStatus,
        // 按钮名称
        buttonsName: this.buttonsName,
        // 操作栏宽度
        optionColumnWidth: this.optionWidth,
        // 是否需要选择
        isSelection: true,
        isStatusButtons: true,
        isHasButtons: false,
        isShowNumber: true,
      };
    },
    searchHighlight() {
      const storeKeyword = (this.params.checkStoreName || "").trim();
      if (storeKeyword) {
        return { keyword: storeKeyword, columns: ["storeName"] };
      }
      const orderKeyword = (this.params.order_id || "").trim();
      if (orderKeyword) {
        return { keyword: orderKeyword, columns: ["outOrdId", "checkOrdId"] };
      }
      const voucherKeyword = (this.params.voucherId || "").trim();
      if (voucherKeyword) {
        return { keyword: voucherKeyword, columns: ["voucherId"] };
      }
      return { keyword: "", columns: [] };
    },
    // 表格事件
    tableEvent() {
      return {
        // 按钮操作
        subOpitonButton: this.handleTableOption,
        // 分页
        subClickPagination: this.handleRefreshList,
        // 表格数据选择
        subSelected: this.handleSelectionChange,
      };
    },
    filterAttrs() {
      return {
        // 按钮名称
        filterButtonText: this.filterButtonText,
        filterOptions: this.filterOptions,
      };
    },
    filterEvent() {
      return {
        // 选择数据回调
        handleFilter: this.handleFilter,
        handleFilterButton: this.handleFilterButton,
        changeDate: this.changeDate,
        clickSearch: this.clickSearch,
      };
    },
    amountDes() {
      return function (val) {
        const obj = {
          1: "预付款",
          2: "渠道金额",
          3: "商户金额",
          4: "门店金额",
        };
        return obj[val];
      };
    },
  },
  beforeRouteLeave(to, from, next) {
    this.saveListState();
    next();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name === "orderListDetail") {
        vm.restoreListState();
      } else {
        sessionStorage.removeItem(ORDER_LIST_STATE_KEY);
      }
      vm.init();
      vm.getList();
    });
  },
  methods: {
    saveListState() {
      sessionStorage.setItem(
        ORDER_LIST_STATE_KEY,
        JSON.stringify({
          listQueryParams: { ...this.listQueryParams },
          params: { ...this.params },
        })
      );
    },
    restoreListState() {
      const cached = sessionStorage.getItem(ORDER_LIST_STATE_KEY);
      if (!cached) return;
      try {
        const state = JSON.parse(cached);
        if (state.listQueryParams) {
          this.listQueryParams = {
            ...this.listQueryParams,
            ...state.listQueryParams,
          };
        }
        if (state.params) {
          this.params = {
            ...this.params,
            ...state.params,
          };
        }
      } catch (error) {
        sessionStorage.removeItem(ORDER_LIST_STATE_KEY);
      }
    },
    init() {
      const params = {
        ...this.params,
        pageSize: 1000,
        pageNum: 0,
      };
      if ([1, 2].includes(this.type)) {
        merchantList(params).then((res) => {
          this.filterOptions[1].options = res.data.list.map((val) => {
            return {
              value: val.merchantId,
              label: val.merchantName,
            };
          });
          this.filterOptions[1].options.unshift({
            value: "",
            label: "所有",
          });
        });
      }
      // 渠道 去掉渠道，
      // 商户，门店   去掉渠道，商户，门店
      if ([1, 3, 4].includes(this.type)) {
        if ([1].includes(this.type)) {
          channelList(params).then((res) => {
            this.filterOptions[2].options = res.data.list.map((val) => {
              return {
                value: val.channelId,
                label: val.channelName,
              };
            });
            this.filterOptions[2].options.unshift({
              value: "",
              label: "所有",
            });
          });
        }
        storesList(params).then((res) => {
          this.filterOptions[3].options = res.data.list.map((val) => {
            return {
              value: val.storeId,
              label: val.storeName,
            };
          });
          this.filterOptions[3].options.unshift({
            value: "",
            label: "所有",
          });
        });
      }
      if ([3, 4].includes(this.type)) {
        this.filterOptions[4].options = [
          {
            value: null,
            label: "所有",
          },
          {
            value: "1",
            label: "已核销",
          },
          {
            value: "2",
            label: "冲正",
          },
        ];
      }
    },
    // 获取列表
    async getList() {
      try {
        // 表格加载loading
        this.loadingStatus = true;
        // 分页数据作为参数给服务端
        this.params.pageSize = this.listQueryParams.pageSize;
        this.params.pageNum = this.listQueryParams.pageNum - 1;
        // 发送请求,请求到的数据格式见下文，
        const { data } = await orderList(this.params);
        const specialStatusStatusType = {
          0: "待核销",
          1: "已核销",
          2: "冲正",
          3: "作废",
          4: "过期",
        };
        const operationStatusStatusType = {};
        if ([1, 2].includes(this.type)) {
          operationStatusStatusType[0] = "作废";
          if ([1].includes(this.type)) {
            operationStatusStatusType[1] = "冲正";
          }
        }
        if ([3, 4].includes(this.type)) {
          operationStatusStatusType[1] = "冲正";
        }

        if (data.list) {
          data.list.forEach((item) => {
            item.status = item.status.toString();
            item.amount = item.amount / 100;
            item.advancePayment = item.advancePayment / 100;
            item.merchantSettlement = item.merchantSettlement / 100;
            item.specialStatus = specialStatusStatusType[item.status];
            item.operationSpecialStatus =
              operationStatusStatusType[item.status];
            item.createYearMonth = this.formatCreateYearMonth(item.createTime);
          });
        }
        this.listQueryParams.total = data.total;
        // 数据给表格
        this.tableData = data.list || [];
        this.tableConfig.forEach((item) => {
          if ([3, 4].includes(this.type)) {
            if (item.value === "merchantSettlement") {
              item.label = this.amountDes(this.type);
            }
          }
          if ([2].includes(this.type)) {
            if (item.value === "advancePayment") {
              item.label = this.amountDes(this.type);
            }
          }
        });
        if ([3].includes(this.type)) {
          this.tableConfig = this.tableConfig.filter(
            (item) => !["channelName", "advancePayment"].includes(item.value)
          );
        }
        if ([4].includes(this.type)) {
          this.tableConfig = this.tableConfig.filter(
            (item) => !["channelName", "advancePayment", 'merchantSettlement'].includes(item.value)
          );
        }
        // 隐藏商户金额
        if ([2].includes(this.type)) {
          this.tableConfig = this.tableConfig.filter(
            (item) => !["merchantSettlement"].includes(item.value)
          );
        }
        this.loadingStatus = false;
      } catch (error) {
        console.log(error);
      }
    },
    changeDate(val) {
      console.log("🚀 ~ changeDate ~ val:", val);
      this.params.startDate = val[0];
      this.params.endDate = val[1];
      // this.dateValue = val;
    },
    handleFilter(val) {
      console.log(
        "🔍 ~ handleFilter ~ src/views/order/orderList/index.vue:363 ~ val:",
        val
      );
      this.params.merchantId =
        val.placeholder === "商户" ? val.selectValue : this.params.merchantId;
      this.params.channelId =
        val.placeholder === "渠道" ? val.selectValue : this.params.channelId;
      this.params.storeId =
        val.placeholder === "门店" ? val.selectValue : this.params.storeId;
      this.params.status =
        // val.placeholder === "状态" ? (val.selectValue ? +val.selectValue : null) : +this.params.status;
        val.placeholder === "状态"
          ? val.selectValue !== null
            ? +val.selectValue
            : null
          : this.params.status;
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 点击编辑  渠道2，平台1只能操作作废   门店4,商户3只能操作冲正
    async handleTableOption(row) {
      // 0-待核销状态，4过期状态 可以操作作废
      if ([0].includes(+row.status) && [1, 2].includes(this.type)) {
        this.$confirm("确认作废吗?", "", {
          type: "warning",
          confirmButtonText: "是",
          cancelButtonText: "否",
        })
          .then(async () => {
            await expireOrder({
              voucherId: row.voucherId,
            });
            this.getList();
            this.$message.success("作废成功");
          })
          .catch(() => {
            this.$message.info(" 已取消作废");
          });
      }
      // 1-已核销状态， 可以操作冲正
      if (+row.status === 1 && [1, 3, 4].includes(this.type)) {
        this.$confirm("确认冲正吗?", "", {
          type: "warning",
          confirmButtonText: "是",
          cancelButtonText: "否",
        })
          .then(async () => {
            await reverseOrder({
              voucherId: row.voucherId,
            });
            this.getList();
            this.$message.success(" 冲正成功");
          })
          .catch(() => {
            this.$message.info(" 已取消冲正");
          });
      }
    },
    // 分页操作
    handleRefreshList() {
      this.getList();
    },
    clickSearch(val) {
      const inputValue = (val.inputValue || "").trim();
      const searchFilter = this.filterOptions.find(
        (item) =>
          item.type === "multiSelect" &&
          item.options &&
          item.options.some((opt) => opt.value === "order_id")
      );
      const selectValue =
        val.selectValue || (searchFilter && searchFilter.selectValue) || "voucherId";
      if (selectValue === "order_id") {
        this.params.order_id = inputValue;
        this.params.voucherId = "";
        this.params.checkStoreName = "";
      } else if (selectValue === "checkStoreName") {
        this.params.checkStoreName = inputValue;
        this.params.voucherId = "";
        this.params.order_id = "";
      } else {
        this.params.voucherId = inputValue;
        this.params.order_id = "";
        this.params.checkStoreName = "";
      }
      this.listQueryParams.pageNum = 1;
      this.getList();
    },
    async fetchAllOrdersForExport() {
      const allList = [];
      let pageNum = 0;
      let total = 0;

      while (true) {
        const { data } = await orderList(
          {
            ...this.params,
            pageSize: EXPORT_PAGE_SIZE,
            pageNum,
          },
          { timeout: EXPORT_REQUEST_TIMEOUT }
        );
        if (pageNum === 0) {
          total = data.total || 0;
        }
        const list = data.list || [];
        if (!list.length) {
          break;
        }
        list.forEach((item) => this.normalizeOrderExportItem(item));
        allList.push(...list);
        pageNum += 1;
        if (list.length < EXPORT_PAGE_SIZE) {
          break;
        }
        if (total > 0 && allList.length >= total) {
          break;
        }
      }

      return allList;
    },
    formatCreateYearMonth(createTime) {
      if (!createTime) {
        return "";
      }
      const str = String(createTime).trim();
      const match = str.match(/^(\d{4})[-/](\d{1,2})/);
      if (match) {
        return `${match[1]}-${String(match[2]).padStart(2, "0")}`;
      }
      const date = new Date(str.replace(/-/g, "/"));
      if (Number.isNaN(date.getTime())) {
        return "";
      }
      const month = String(date.getMonth() + 1).padStart(2, "0");
      return `${date.getFullYear()}-${month}`;
    },
    normalizeOrderExportItem(item) {
      item.status = item.status.toString();
      item.amount = item.amount / 100;
      item.advancePayment = item.advancePayment / 100;
      item.merchantSettlement = item.merchantSettlement / 100;
      item.createYearMonth = this.formatCreateYearMonth(item.createTime);
    },
    async exportExcel() {
      let headers = [
        "券码ID",
        "年月",
        "券码金额",
        "券码名称",
        "商户",
        "核销门店",
        [3, 4].includes(this.type) ? this.amountDes(this.type) : "商户金额",
        "渠道",
        [2].includes(this.type) ? this.amountDes(this.type) : "渠道金额",
        "创建时间",
        "过期时间",
        "操作时间",
        "核销时间",
        "状态",
        "商户订单号",
        "核销单号",
        "外部卡号",
      ];
      let keys = [
        "voucherId",
        "createYearMonth",
        "amount",
        "voucherDesc",
        "merchantName",
        "storeName",
        "merchantSettlement",
        "channelName",
        "advancePayment",
        "createTime",
        "expireTime",
        "statusTime",
        "operateTime",
        "specialStatus",
        "outOrdId",
        "checkOrdId",
        "cardNo",
      ];
      const statusType = {
        0: "待核销",
        1: "已核销",
        2: "冲正",
        3: "作废",
        4: "过期",
      };
      if ([3].includes(this.type)) {
        keys = keys.filter((item) => {
          return ![
            "channelName",
            "advancePayment",
          ].includes(item);
        });
        headers = headers.filter((item) => {
          return !["渠道", "渠道金额"].includes(item);
        });
      }
      if ([4].includes(this.type)) {
        keys = keys.filter((item) => {
          return ![
            "channelName",
            "advancePayment",
            'merchantSettlement'
          ].includes(item);
        });
        headers = headers.filter((item) => {
          return !["渠道", "渠道金额",'门店金额'].includes(item);
        });
      }
      if ([2].includes(this.type)) {
        keys = keys.filter((item) => {
          return !["merchantSettlement"].includes(item);
        });
        headers = headers.filter((item) => {
          return !["商户金额"].includes(item);
        });
      }
      let arr = [];
      let exportData = [];
      const loading = this.$loading({
        lock: true,
        text: "正在导出，请稍候...",
      });
      try {
        if (this.multipleSelection.length) {
          arr = this.multipleSelection;
        } else {
          arr = await this.fetchAllOrdersForExport();
        }
        if (!arr.length) {
          this.$message.warning("暂无数据可导出");
          return;
        }
        exportData = arr.map((item) => {
          item.specialStatus = statusType[item.status];
          return keys.map((key) => {
            if (key === "operateTime" && !["1", "2"].includes(String(item.status))) {
              return "";
            }
            return item[key];
          });
        });
        exportData.unshift(headers);
        const ws = XLSX.utils.aoa_to_sheet(exportData);
        const colWidthMap = {
          券码ID: 15,
          年月: 10,
          券码金额: 10,
          券码名称: 25,
          商户: 15,
          核销门店: 15,
          商户金额: 20,
          门店金额: 20,
          渠道: 20,
          渠道金额: this.type === 2 ? 21 : 10,
          创建时间: 21,
          过期时间: 21,
          操作时间: 21,
          核销时间: 21,
          状态: 10,
          商户订单号: 20,
          核销单号: 20,
          外部卡号: 20,
        };
        ws["!cols"] = headers.map((header) => ({
          wch: colWidthMap[header] || 15,
        }));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
        XLSX.writeFile(wb, `订单记录${getPathName()}.xlsx`);
      } catch (error) {
        console.log(error);
        this.$message.error("导出失败，请稍后重试");
      } finally {
        loading.close();
      }
    },
    // 点击右上角添加门店或者删除门店按钮
    async handleFilterButton(val) {
      if (val === "导出Excel") {
        this.exportExcel();
      }
    },
  },
};
</script>
<style lang="scss">
.order-list {
  .filter-container {
    .el-input {
      width: 265px;
      input {
        height: 32px;
      }
      .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
    }
    .select-item.order-search-field {
      .el-select .el-input {
        width: 136px !important;
      }
      > .el-input {
        width: 264px !important;
      }
      .el-select .el-input__inner {
        padding-right: 24px;
      }
    }
    .el-select {
      margin-right: 0px;
      .el-input {
        width: 150px;
      }
    }
    .el-input-group__append {
      background: #fff;
    }
    .el-button {
      padding: 12px;
    }
    .filter-container__right {
      .el-button {
        width: 88px;
        height: 32px;
        line-height: 32px;
        padding: 0;
        font-size: 14px;
      }
      .el-button--primary {
        background: #1890ff;
      }
      .el-button--info {
        background: #f5f5f5;
        color: rgba(0, 0, 0, 0.25);
      }
    }
  }
  .deleteShopDialog {
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      display: flex;
      align-items: center;
      border: none;
    }
    .el-icon-warning-outline {
      font-size: 22px;
      color: #faad14;
      margin-right: 16px;
    }
    .el-dialog__footer {
      padding: 0px 20px 20px;
    }
  }
}
</style>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
.order-list {
  .filter-container {
    @include flex;
    justify-content: space-between;
    // padding: 0 24px;
    width: 100%;
    // height: 80px;
    background: #fff;
  }
  .show-pwd {
    position: absolute;
    right: 60px;
    top: 0;
    font-size: 16px;
    color: #000;
    cursor: pointer;
    user-select: none;
  }
  .char-count {
    text-align: right;
    color: #666;
    font-size: 12px;
    margin-top: 4px;
  }

  .limit-reached {
    color: #f56c6c;
    font-weight: bold;
  }
}
</style>
